
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { AccessUpdateRequestType } from "./accessUpdate.types";
import { IAccess, IAccessListItem } from "@/entity/salons/access.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class AccessUpdateForm extends Form {

    @Validate(required, i18nText("Введите назавание сервиса"))
    id: number | null = null;
    access_data_name_id: number | null = null;
    name: string | null = null;
    login: string | null = null;
    password: string | null = null;
    link: string | null = null;
    salon_id: number | null = null;

    getFormData(): AccessUpdateRequestType {
       return{
            id: this.id,
            access_data_name_id: this.access_data_name_id,
            name: this.name,
            login: this.login,
            password: this.password,
            link: this.link,
            salon_id: this.salon_id,
       } 
    }

    setFormData(access: IAccessListItem): void {
        if(access != null && access != undefined){
            this.id = access.id;
            this.access_data_name_id = access.access_data_name_id;
            this.name = access.name.name;
            this.login = access.login;
            this.password = access.password;
            this.link = access.link;
            this.salon_id = access.salon_id;
        }
    }
}
